// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function FilterManagementTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Filter Management</p>
      <p>
        Track irrigation and HVAC filter maintenance — create templates, log cleanings and
        replacements, and stay ahead of overdue service.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Logger — record maintenance by filter type, set intervals, and attach photos.</li>
          <li>Records — review templates, history, and status across the facility.</li>
          <li>Calendar — see upcoming, completed, and missed maintenance at a glance.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Key features</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Overdue and due-soon counts on the Arca dashboard</li>
          <li>Reusable templates for recurring filter locations</li>
          <li>Click calendar events to log or update maintenance inline</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Set realistic intervals when creating templates — the calendar drives daily maintenance visibility.
      </p>
    </div>
  );
}
